import { ExtensibilityService } from "@amazon-connect/extensibility";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/**
 * Generic interceptor registration. Off by default, always pass-through.
 *
 * `ExtensibilityService` takes the provider directly, not `{ provider }` (amendment A7).
 */
export const extensibilityModule: ClientModule = {
  id: "extensibility",
  label: "Extensibility (interceptors)",
  pkg: "@amazon-connect/extensibility",
  clientExport: "ExtensibilityService",
  kind: "interceptor",
  create: (provider: AmazonConnectProvider) =>
    new ExtensibilityService(provider) as unknown as Record<string, unknown>,
  events: [],
  requests: [
    { name: "addInterceptor", args: [], mutating: true },
    { name: "removeInterceptor", args: [], mutating: true },
  ],
};
